import { render, staticRenderFns } from "./VersionInformation.vue?vue&type=template&id=361ca63a&"
import script from "./VersionInformation.vue?vue&type=script&lang=ts&"
export * from "./VersionInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports